import { IPromise } from 'angular';
import * as _ from 'underscore';
import { Messages } from '../../codegen/Localize';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { IWorkbookBase } from '../models/IWorkbookInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Workbooks } from '../resources/Workbooks';
import { IResult } from '../ServerApi/types/IResponse';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { actionErrorTranslation, actionSuccessTranslation, INotificationTranslationFns } from './ContentActionNotification';
import { ModalSize } from './ModalService';
import { WorkbookErrors } from './WorkbookErrors';


export class SetDisplayTabsAction {

  public static $inject = ['ConfirmActionDialog', '$translate', 'Workbooks', 'WorkbookErrors'];

  constructor(
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private Workbooks: Workbooks,
    private WorkbookErrors: WorkbookErrors
  ) {}

  public confirmSetDisplayTabs(
      workbooks: Set<IWorkbookBase>,
      context: IActionContext): IPromise<any> {

    const workbookArray = workbooks.toArray();
    const anyTabsEnabled = _.any(workbookArray, (wb: IWorkbookBase) => wb.displayTabs);
    const anyTabsDisabled = _.any(workbookArray, (wb: IWorkbookBase) => !wb.displayTabs);

    return this.ConfirmActionDialog.open({
      scope: context.scope,
      title: this.$translate.instant('confirmSetDisplayTabsTitle'),
      bodyText: this.$translate.instant('confirmSetDisplayTabsPrompt', {
        ITEM_COUNT: workbooks.size(),
        ITEM_NAME: L10n.elideIfLong(workbooks.first().name)
      }, L10n.Interpolations.Count),
      buttons: [
        {
          label: this.$translate.instant('confirmSetDisplayTabsShowButton'),
          testId: 'confirm-show-tabs',
          action: this.setDisplayTabsAction(workbooks, true),
          disabled: () => !anyTabsDisabled
        },
        {
          label: this.$translate.instant('confirmSetDisplayTabsHideButton'),
          testId: 'confirm-hide-tabs',
          action: this.setDisplayTabsAction(workbooks, false),
          disabled: () => !anyTabsEnabled
        }
      ],
      size: ModalSize.large
    }).result;

  }

  private setDisplayTabsAction(workbooks: Set<IWorkbookBase>, displayTabs: boolean) {
    return () => this.Workbooks.setDisplayTabs(workbooks.keys(), displayTabs)
      .then((result: IResult) => this.notifyResult(displayTabs, workbooks, result));
  }

  private notifyResult(displayTabs: boolean, workbooks: Set<IWorkbookBase>, result: IResult) {

    const translations: INotificationTranslationFns = displayTabs ?
      {
        success: actionSuccessTranslation(Messages.setDisplayTabsShowSuccess),
        error: actionErrorTranslation(Messages.setDisplayTabsShowError),
      } : {
        success: actionSuccessTranslation(Messages.setDisplayTabsHideSuccess),
        error: actionErrorTranslation(Messages.setDisplayTabsHideError),
      };

    ActionHelpers.notifyStandardError(
      workbooks,
      result,
      translations,
      (errorItem: IErrorItem<IWorkbookBase>) => this.WorkbookErrors.errorDetailsFor(errorItem)
    );
  }

}

Module.instance().service('SetDisplayTabsAction', SetDisplayTabsAction);
